import { render } from "./WpeThemeInfo.vue?vue&type=template&id=e10ce0de"
import script from "./WpeThemeInfo.vue?vue&type=script&lang=js"
export * from "./WpeThemeInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/templates/WpeThemeInfo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e10ce0de"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e10ce0de', __exports__)) {
    api.reload('e10ce0de', __exports__)
  }
  
  module.hot.accept("./WpeThemeInfo.vue?vue&type=template&id=e10ce0de", () => {
    api.rerender('e10ce0de', render)
  })

}


export default __exports__